import { ApiErrorEnum } from '../enums/ApiErrorEnum';

export type ConvertToPdfApiErrorCopy = {
  titleKey: string;
  params?: Record<string, unknown>;
};

/**
 * Maps sync convert-to-PDF API error codes to i18n keys (POST /convert-to-pdf).
 */
export function resolveConvertToPdfApiErrorCopy(
  errorCode: string | undefined,
  maxSizeMb?: number,
): ConvertToPdfApiErrorCopy | null {
  switch (errorCode) {
    case ApiErrorEnum.FileNotFound:
      return { titleKey: 'errors.fileNotFound' };
    case ApiErrorEnum.PdfConversionUnsupportedFormat:
      return { titleKey: 'errors.pdfConversionUnsupportedFormat' };
    case ApiErrorEnum.PdfConversionFileTooLarge:
      return {
        titleKey: 'errors.pdfConversionFileTooLarge',
        params: { maxSizeMb: maxSizeMb ?? 100 },
      };
    case ApiErrorEnum.PdfConversionAntivirusBlocked:
      return { titleKey: 'errors.pdfConversionAntivirusBlocked' };
    case ApiErrorEnum.PdfConversionFailed:
      return { titleKey: 'errors.pdfConversionFailed' };
    default:
      return null;
  }
}

/**
 * Maps pdf_conversion WS / poll error tokens to i18n keys under errors.*
 */
export function resolvePdfConversionTerminalErrorMessage(
  errorCode: string | undefined,
  translate: (key: string, options?: Record<string, unknown>) => string,
): string {
  if (!errorCode) {
    return translate('errors.pdfConversionFailed');
  }

  const normalized = errorCode.trim().toLowerCase();
  const directKey = `errors.${normalized}`;
  const direct = translate(directKey);
  if (direct !== directKey) {
    return direct;
  }

  const enumKey = Object.values(ApiErrorEnum).find((value) => value.toLowerCase() === normalized);
  if (enumKey) {
    const copy = resolveConvertToPdfApiErrorCopy(enumKey);
    if (copy) {
      return translate(copy.titleKey, copy.params);
    }
  }

  return translate('errors.pdfConversionFailed');
}
